import { Chip, Box, Stack } from '@mui/material'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { VariableText } from 'components/core/variable-text'
import { AppDisplayName } from 'components/pages/app/app-display-name'
import { userStatusToIntl } from 'components/pages/user/type'
import { UserValue } from 'lib/actions/user'
import { UserStatus } from 'pbts/c1/api/user/v1/user'
import { FC } from 'react'
import { IntlShape } from 'react-intl'

export type UserDirectoriesProps = { user?: UserValue; intl: IntlShape; readOnly?: boolean }

export const UserDirectories: FC<UserDirectoriesProps> = ({ user, readOnly = false }) => {
    if (!user) {
        return null
    }

    if (!user.directories || user.directories?.length === 0) {
        return <C1EmptyIndicator />
    }

    return (
        <Stack gap={2}>
            {user.directories?.map((directory) => (
                <Box key={directory.id}>
                    <AppDisplayName margin={false} app={directory} readOnly={readOnly} />
                </Box>
            ))}
        </Stack>
    )
}

export const UserDirectoryStatus: FC<UserDirectoriesProps> = ({ user, intl }) => {
    if (!user) {
        return null
    }

    const isUserEnabled = user.directoryStatus === UserStatus.ENABLED
    return (
        <Box display="flex" width="100%">
            <Chip color={isUserEnabled ? 'success' : 'info'} label={userStatusToIntl(user.directoryStatus, intl)} />
        </Box>
    )
}

export const UserJob: FC<UserDirectoriesProps> = ({ user }) => user &&
    <Box display="flex" width="100%">
        <VariableText
            width="100%"
            noWrap
            variableText={user.jobTitle}
        />
    </Box>

export const UserEmployeeId: FC<UserDirectoriesProps> = ({ user }) => user &&
    <VariableText
        width="100%"
        noWrap
        variableText={user?.employeeIds?.join(', ')}
    />
